export enum ResponsiveCalendarOption {
  ValidRange = 'validRange',
}
